export const ROOM_STATE_MAX_ALLOWED_USERS = 8

export const MAX_GROUP_NAME_LENGTH = 100

export const GROUPING_SIZE_DEFAULT = 5
export const GROUPING_SIZE_MAXIMUM_DEFAULT = 5
export const GROUPING_SIZE_MINIMUM_DEFAULT = 1

export const PRE_MEETING_QUESTION_SLIDE_ID = 'pre-meeting-quiz'
